import React from 'react';
import { useClinicalReports } from '../../clinical-reports/ClinicalReportsContext';
import ReportSectionHead from '../../head-doctor/reports/ReportSectionHead';
import { NursingFamilyPlanningReportSection } from '../../head-doctor/reports/nursingReportSections';

export default function MajorReportsPlanningFamilialPage() {
  const { data, summary, loading, copy: COPY, hasActiveAdvancedFilters, clearAdvancedFilters } =
    useClinicalReports();

  return (
    <>
      <ReportSectionHead
        badge={COPY.SUB_PLANNING_FAMILIAL}
        title={COPY.PAGE_PLANNING_FAMILIAL_TITLE}
        description={COPY.PAGE_PLANNING_FAMILIAL_DESC}
      />

      <NursingFamilyPlanningReportSection
        data={data}
        summary={summary}
        loading={loading}
        copy={COPY}
        emptyHint={COPY.EMPTY_FILTERED_HINT}
        clearFiltersLabel={COPY.EMPTY_CLEAR_FILTERS}
        onClearFilters={hasActiveAdvancedFilters ? clearAdvancedFilters : null}
      />
    </>
  );
}
